
.main_body{
    width: 90%;
    margin: 20px;
}

.searchContainer{
    padding: 20px;
    margin-bottom: 30px;
    border-bottom: 1px dashed lightgray;  
}
.searchContainer input{
    margin-right: 20px;
    padding: 15px 20px;
    font-size: 15px;
    width: 300px;
    border: 1px solid #c1c0c0;
    border-radius: 50px;
}

.searchContainer input:focus {
    outline: none;
}
.restaurants_list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
.restaurants_list a {
    color: inherit;
   text-decoration: none;
}
.restaurant{
    width: 250px;
    text-align: left;
    padding: 20px;
    margin-right: 3px;
}
.restaurant:hover{
    cursor: pointer;
    box-shadow: 0 0 10px rgba(78, 90, 255, 1);
}

.restaurant_img {
    width: 100%;
    height: 160px;
    margin-bottom: 10px;
}

.restaurant_img  img{
    width: 100%;
    height: 100%;
}

.restaurant_name{
    font-weight: bold;
    margin-bottom: 5px;
}
.restauranr_cuisine{
    font-size: 12px;
    color: rgb(69, 68, 68);
    margin-bottom: 15px;
    word-wrap: break-word;
}
.restaurant_details{
    display: flex;
    font-size: 12px;
    color: rgb(69, 68, 68);
    justify-content: space-between;
}
.restaurant_rating{
    background-color: #48c479;
    color: white;
    padding: 2px 10px;
    align-items: center;
}
.restaurant_rating span img{
    height: 12px;
    margin-right:2px;
}

